/** @file Doc store: the open project's id and its DocSlice (confirmed doc, pending commands, rev). */
import { createStore } from 'zustand/vanilla';
import type { DocSlice } from './types';

/** `slice` is null until GET /projects/:id/doc answers for `projectId`. */
export interface DocState {
  projectId: string | null;
  slice: DocSlice | null;
}

/** Vanilla store; the document changes only through commands (optimistic apply is Wave 3). */
export const docStore = createStore<DocState>()(() => ({ projectId: null, slice: null }));
